import { MediaProps } from '~/components/cms/Media/Media.vue'
import { ActionFields } from '~/components/cms/Action/actionHelpers'

export type CardFields = {
  fields?: {
    graphic?: [MediaProps]
    action?: [ActionFields]
    text?: string
    title?: string
    supportingData?: {
      home?: {
        variant?: {
          value?: string
        }
      }
    }
  }
}

export function cardTransformer(card: CardFields) {
  const fields = card?.fields
  const action = fields?.action?.[0]
  const { text, title } = fields || {}
  const media = card?.fields?.graphic?.[0]

  return { action, media, text, title }
}
